import slidesIcon from '../../assets/DasboardIcons/slides.svg';
import boardIcon from '../../assets/DasboardIcons/board.png';
import mindmapIcon from '../../assets/DasboardIcons/mindmap.svg';
import ideationIcon from '../../assets/DasboardIcons/ideation.svg';
import spacesIcon from '../../assets/DasboardIcons/spaces.svg';
import padIcon from '../../assets/DasboardIcons/pad.png';
import moodIcon from '../../assets/DasboardIcons/mood.png';

/** The Workw apps the launcher offers; shared with the header's compact menu. */
export const apps = [
  { id: 'pad', name: 'Pad', icon: padIcon, url: 'https://pad.workw.com/' },
  { id: 'slides', name: 'Slides', icon: slidesIcon, url: 'https://slides.workw.com/' },
  { id: 'board', name: 'Board', icon: boardIcon, url: 'https://board.workw.com/' },
  { id: 'mindmap', name: 'Mindmap', icon: mindmapIcon, url: 'https://map.workw.com/' },
  { id: 'ideation', name: 'Ideation', icon: ideationIcon, url: 'https://ideation.workw.com/' },
  { id: 'spaces', name: 'Spaces', icon: spacesIcon, url: 'https://spaces.workw.com/' },
  { id: 'mood', name: 'Mood', icon: moodIcon, url: 'https://mood.workw.com/' },
];

export const openApp = (url) => window.open(url, '_blank', 'noopener,noreferrer');
